import type { PmMarkConverter } from './../../pm-converters/types';
import type { Decoration as LegacyDecoration } from './../../ricos-schema/legacy/wix/rich_content/v1';
import { Decoration_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { FontSizeDecoration } from './../../ricos-schema/next-schema';
export const fontSizeConverter: PmMarkConverter = {
  fromPm: {
    type: Decoration_Type.FONT_SIZE,
    convert: mark => {
      const { attrs } = mark;
      if (!attrs || !attrs.value) {
        return [];
      }
      return [
        {
          type: Decoration_Type.FONT_SIZE,
          fontSizeData: {
            value: attrs.value,
            // if attrs.unit is 'PX' we should not save it since it defaults to that anyway,
            // but old versions of viewer will be angry if it's not there, so we keep it for now
            unit: attrs.unit ?? 'PX',
          },
        } satisfies FontSizeDecoration as LegacyDecoration,
      ];
    },
  },
  toPm: {
    type: Decoration_Type.FONT_SIZE,
    convert: decoration => {
      const { fontSizeData } = decoration;
      if (!fontSizeData || !fontSizeData.value) {
        return undefined;
      }
      return {
        type: Decoration_Type.FONT_SIZE,
        attrs: {
          value: fontSizeData.value,
          unit: fontSizeData.unit ?? 'PX',
        },
      };
    },
  },
};
